<template>
    <div>

        <div v-if="editPermissao && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitPermissao" v-if="!editPermissao || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editPermissao || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                            <el-select v-model="dados.situacao">
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
                            <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Chave" prop="chave" :rules="[$requiredBlur]" key="chave">
                            <el-input v-model="dados.chave" maxlength="191" v-on:blur="formatChave()"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Descrição" prop="descricao" key="descricao">
                            <el-input type="textarea" :rows="2" v-model="dados.descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-permissao" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editPermissao: false,
        dados: {
            id: '',
            situacao: true,
            nome: '',
            chave: '',
            descricao: ''
        }
    }),
    methods:{
        getPermissaoById(id){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/permissao/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {
                this.dados = JSON.parse(JSON.stringify(response.data));
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        onSubmitPermissao(){

            document.getElementById("btn-permissao").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                if(this.editPermissao){
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/permissao/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitPermissao');
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }else{
                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/permissao/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('onSubmitPermissao');
                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        formatData(field, size = null){
            if(!this.dados[field]) return false;
            if(size && this.dados[field].length < size) this.dados[field] = '';
            this.dados[field] = this.dados[field].toUpperCase();
            this.dados[field] = this.$removerAcentos(this.dados[field]);
        },
        formatChave(){
            if(!this.dados.chave) return;
            this.dados.chave = this.dados.chave.toUpperCase();
            this.dados.chave = this.$removerAcentos(this.dados.chave);
            this.dados.chave = this.dados.chave.replace(/\s+/g, '_').replace(/[^A-Z0-9_]/g, '_');
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if(value){
                    this.getPermissaoById(value);
                    this.editPermissao = true;
                }
            }
        },
    }
}
</script>

